import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Slider from "Shared/Slider";
import { analyticsFEA } from "src/AnalyticsFEA";
import { ApplicationStore } from "src/store";
import { patchPaymentsRequest } from "src/store/actions/payments";
import { getDownPayment, getVehicle, getVehiclePrice } from "src/store/selectors/vehicles";
import { getCountry } from "src/store/selectors/account";
import CurrencyInput from "Shared/CurrencyInput";
import classnames from "classnames";

interface Props {
    vin: string;
    paymentType: "loan" | "lease";
}

const DownPayment = ({
    country,
    paymentType,
    downPayment,
    maxDownPayment,
    uuid,
    vin,
    patchPayments,
    vehicle,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    const handleChange = (value: number, fieldType: "slider" | "input") => {
        patchPayments(
            uuid,
            vin,
            {
                [paymentType]: {
                    down_payment: value,
                },
            },
            "set_down_payment",
            fieldType
        );

        analyticsFEA.engine.calculationStart(uuid, [vehicle]);
    };

    return (
        <div
            className={classnames("CalculatorSlider", {
                error: downPayment > maxDownPayment,
            })}
        >
            <div className="CalculatorSlider__container--input">
                <CurrencyInput
                    customWrapperClass={"CalculatorSlider__currency_input_wrapper"}
                    className={classnames("CalculatorSlider__input", {
                        error: downPayment > maxDownPayment,
                    })}
                    value={downPayment}
                    maxValue={maxDownPayment}
                    updateValue={(value) => {
                        handleChange(value, "input");
                    }}
                    debounceUpdates={true}
                />
            </div>
            <div className="CalculatorSlider__container--slider">
                <Slider
                    className="CalculatorSlider__slider"
                    min={0}
                    max={10000}
                    sliderValue={downPayment}
                    step={500}
                    onChange={(value: number) => {
                        handleChange(value, "slider");
                    }}
                    tickPrefix={country === "CA" ? "CA$" : "$"}
                    tickLabel="k"
                    ticks={[0, 2, 4, 6, 8, 10]}
                    controlled={true}
                />
            </div>
            {downPayment > maxDownPayment && (
                <span className="CalculatorSlider__container--error">
                    {t("CustomizePayment.PaymentFields.Sliders.DownPayment.error")}
                </span>
            )}
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => {
    return {
        vehicle: getVehicle(state, vin),
        maxDownPayment: getVehiclePrice(state, vin),
        downPayment: getDownPayment(state, vin),
        uuid: state.deal.uuid as string,
        country: getCountry(state),
    };
};

const mapDispatchToProps = {
    patchPayments: patchPaymentsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownPayment);
